export default {
  onImageChange: "onImageChange",
};
